// extracted by mini-css-extract-plugin
export default {"wrapper":"IconList_wrapper__F+2ln","item":"IconList_item__QliOq","right":"IconList_right__k-4EE"};